import { reactive, toRefs, provide, inject } from "@vue/composition-api";

export const state = reactive({
    breadcrumbs: [],
    breadcrumbsViewName: ""
});

export const actions = {
    setBreadcrumbs(breadcrumbs, breadcrumbsViewName) {
        state.breadcrumbs = breadcrumbs;
        state.breadcrumbsViewName = breadcrumbsViewName
    }
};

export const getters = {
    getActionButtons() {
        return state.actionButtons
    }
};

export const key = Symbol("BreadcrumbsModule");

export const provideBreadcrumbs = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
